import { useGroundingStore } from 'modules/Grounding/store/useGroundingStore'
import shallow from 'zustand/shallow'
import { StyledConfirmModal } from './RecallModal.styled'
import { useGlobalStore } from 'store/useGlobalStore'
import { formatDate } from 'utils/dateUtils'
import { ISystemSetting } from 'types/baseTypes'

interface IProps {
  show: boolean
  events?: {
    onClose: any
    setShowModal?: any
    handleAcknowledgedConfirm?: any
  }
}

const RecallModal = ({ show, events }: IProps) => {
  const [groundingData] = useGroundingStore((state) => [state.groundingData], shallow)
  const [getLocalText] = useGlobalStore((state) => [state.getLocalText])
  const openRecallCampaignID = getLocalText('OPEN_RECALL_CAMPAIGN_ID', 'Open Recall Campaign ID')
  const openRecallEffectiveDate = getLocalText('OPEN_RECALL_EFFECTIVE_DATE', 'Effective Date')
  const openRecallDetails = getLocalText('OPEN_RECALL_DETAILS', 'Recall Details')
  const groundingOpenRecallClearingMessage = getLocalText(
    'GROUNDING_OPEN_RECALL_CLEARING_MESSAGE',
    'Note: The open recall must be cleared before retailing'
  )
  const { getFeatureToggle } = useGlobalStore()
  const showRecallAcknowledgement = getFeatureToggle('RecallAcknowledgement') as string

  return (
    <StyledConfirmModal
      show={show}
      onHide={() => events.onClose()}
      backdrop={Number(showRecallAcknowledgement) === 1 ? 'static' : true}
      centered
    >
      <div className="recall-dialog-container">
        <div className="recall-dialog-title">
          <p className="recall-dialog-title-text">
            {Number(showRecallAcknowledgement) !== 1 && (
              <button className="close" onClick={() => events.onClose()}>
                X
              </button>
            )}
            <img alt="" className="recall-dialog-title-icon" src="/content/img/warningwhite.png" />
            {'Open Recall -  '}
            <span>{groundingData?.VIN}</span>
          </p>
        </div>
        <div className="modal-body recall-dialog-content">
          {groundingData?.RecallCollection &&
            groundingData?.RecallCollection.RecallDetails &&
            groundingData?.RecallCollection.RecallDetails.map((detail, index) => (
              <div key={'recall' + index}>
                <p>
                  <b>
                    <span>{openRecallCampaignID}</span>: <span>{detail.OpenRecallCampaignID}</span>
                  </b>
                </p>
                {detail.RecallEffectiveDate !== undefined && detail.RecallEffectiveDate && (
                  <p>
                    <span>{openRecallEffectiveDate}</span>:
                    <span> {formatDate(detail.RecallEffectiveDate, 'MM/dd/yyyy')}</span>
                  </p>
                )}
                {detail.RecallDetails !== undefined && detail.RecallDetails && detail.RecallDetails !== '' && (
                  <p>
                    <span>{openRecallDetails}</span>: <span>{detail.RecallDetails}</span>
                  </p>
                )}
              </div>
            ))}
          <div>{groundingOpenRecallClearingMessage}</div>
          {Number(showRecallAcknowledgement) === 1 && (
            <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
              <button
                className="recall-dialog-acknowledge-button"
                data-dismiss="modal"
                onClick={() => events.onClose()}
              >
                Click here to acknowledge
              </button>
            </div>
          )}
        </div>
      </div>
    </StyledConfirmModal>
  )
}

export default RecallModal
